export default {
    calls:          'Звонки',
    comment:        'Комментарий',
    dateTimeFull:   'DD.MM.YY г., HH:mm:ss',
    forms:          'Заявки',
    send:           'Отправить',
    somethingWrong: 'Что-то пошло не так',
    understood:     'Понятно',
};
